import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";
import Chart from "../../components/widgets/Chart.jsx";
// import { adminWidgets } from "../../variables/adminWidgets";


class EnergyWidgetsPage extends React.Component {


    state = {
        // info: {
        modules: []
        // }
    }


    componentDidMount() {
        // this.setState({ modules: Object.values(adminWidgets) })
    }





    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: this.props.title, button: {} }}
                title={this.props.title}
                description={this.props.description}
                className="pt-4"
            // style={{backgroundColor:'#8e8e8e'}}
            >

                <div className={"row m-0  "}>

                    <div className="col-12 pt-0 pb-4 ">

                        <div className="px-0 mt-0 mb-4">
                            <p className="text-ultra-big " style={{ fontWeight: '500', color: '#222' }}>{this.props.title}</p>
                            <p className="text-small mt-2" style={{ color: '#456' }}>{this.props.description}</p>
                        </div>

                        <div className="row m-0">
                            <div className="col-6">
                                <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} className="py-5">
                                    <p className="px-5 mb-4">اولویت بر اساس مصرف (گیگاژول)</p>
                                    <Chart chartType='pie' />
                                </div>
                            </div>
                            <div className="col-6">
                                <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} className="py-5">
                                    <p className="px-5 mb-4">بها X مصرف</p>
                                    <Chart chartType='pie' />
                                </div>
                            </div>

                            <div className="col-12 mt-4">
                                <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} className="py-5">
                                    <p className="px-5 mb-4">مصارف اخیر (Gj)</p>
                                    <Chart chartType='line' />
                                </div>
                            </div>
                            {/* {this.state.modules?.map((prop) => {
                                let Component = WidgetComponents[prop.key]
                                if (Component && checkPermission(prop.permissionParent + '.view')) {

                                    let variables = {
                                        permissionRoot: prop.permissionParent
                                    }

                                    return (
                                        <div className={"w-100 mb-1 p-1 col-12  col-md-" + (prop.col ?? "6")} key={prop._id}>
                                            <div className="h-100 py-2 px-1 d-flex flex-column" style={{ backgroundColor: '#fff', borderRadius: 4 }}>
                                                <p className="text-start text-bold mt-2 mb-3 text-normal">{prop.title}</p>
                                                <Component widget={prop} dashboard={this.state.info} variables={variables} />
                                            </div>
                                        </div>
                                    )
                                }
                            })} */}
                        </div>

                        {/* <DataGrid isLoading={this.state.isLoading} data={this.props.modules} component={AdminModule} col="col-12 col-sm-6 col-md-6 col-lg-3" settings={{route:this.props.route}} /> */}
                    </div>
                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnergyWidgetsPage);
